import api from '../../store/api/api';

// Shared Uber address-autocomplete fetch. `center`, if given, geobiases
// results around { lat, lon } -- Uber's autocomplete endpoint takes this as
// latitude/longitude query params.
export const fetchAddressSuggestions = async (query, center) => {
  const params = { query };
  if (center) {
    params.latitude = center.lat;
    params.longitude = center.lon;
  }
  const response = await api.get('/uber/address-autocomplete', params);
  const data = response.data || {};
  return data.data?.addresses || data.addresses || [];
};

export default fetchAddressSuggestions;
